import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AvantoLambdaService } from 'src/app/services/avanto-lambda.service';
import { AvantoRoutingService } from 'src/app/services/avanto-routing.service';
import { AvantoUserAuthService } from 'src/app/services/avanto-user-auth.service';
import Swal from 'sweetalert2'
import { generateCognitoPhoneFormat } from '../CustomerPortalUtil';
import { AvantoCognitoService } from 'src/app/services/avanto-cognito.service';

@Component({
  selector: 'app-customer-authentication',
  templateUrl: './customer-authentication.component.html',
  styleUrls: ['./customer-authentication.component.scss']
})
export class CustomerAuthenticationComponent implements OnInit {

  readonly SIGN_IN = "signIn";
  readonly SIGN_IN_AND_CHECKOUT = "signInCheckout";
  readonly SIGN_UP = "signUp";
  readonly SIGN_UP_AND_CHECKOUT = "signUpCheckout";
  readonly SIGN_UP_CONFIRMATION = "signUpConfirmation";
  readonly FORGOT_PASSWORD = "forgotPassword";

  displayedComponent: string;
  title: string;
  bottomTitleTxt: string;

  selectedUsername: string;
  selectedPassword: string;

  showLoadingOverlay: boolean;
  numberOfTimesTryAgainClicked: number;

  goToCheckoutAfterSignIn: boolean;

  private Toast = Swal.mixin({ toast: true, position: 'top-end', showConfirmButton: false, timer: 10000 })

  constructor(private route: ActivatedRoute, private cognito: AvantoCognitoService, private avantoRoute: AvantoRoutingService, private auth: AvantoUserAuthService) { }

  ngOnInit() {
    this.showLoadingOverlay = false;
    this.goToCheckoutAfterSignIn = false;
    this.numberOfTimesTryAgainClicked = 0

    // Gets the 'page' argument on the route and use it to determine which view will be displayed
    switch (this.route.snapshot.params['page']) {
      case this.SIGN_UP_AND_CHECKOUT:
        this.goToCheckoutAfterSignIn = true;
      case this.SIGN_UP:
        this.switchToSignUp();
        break;
      case this.FORGOT_PASSWORD:
        this.switchToForgotPassword()
        break;

      //Sign in is the default view! If there are any problems with the route, we will switch to it!
      case this.SIGN_IN_AND_CHECKOUT:
        this.goToCheckoutAfterSignIn = true;
      case this.SIGN_IN:
      default:
        this.switchToSignIn();
        break;
    }
  }

  confirmAuthHorribleError() {
    this.switchToSignUp();
  }

  /** Goes to the Sign In screen */
  switchToSignIn() {
    this.displayedComponent = this.SIGN_IN;
    this.title = "Sign in to your account";
    this.bottomTitleTxt = "Don't have an account yet?"
  }

  /** Goes to the Sign In screen */
  switchToForgotPassword() {
    this.displayedComponent = this.FORGOT_PASSWORD;
    this.title = "Select a new password";
    this.bottomTitleTxt = "Don't have an account yet?"
  }

  /** Called when you try to Sign In */
  signInClicked(selectedValues) {
    this.setSelectedUsrPassword(selectedValues);
    //I need to convert the username (which is a phone) to the stupid format used by cognito
    this.signIn(this.selectedUsername, this.selectedPassword)
  }

  /** The confirm authentication code was correct! The user is authenticaded and we sign in ! */
  confirmAuthSucceeded() {
    this.switchToSignIn();
    this.signIn(this.selectedUsername, this.selectedPassword);
  }
  confirmAuthFailed() {
    this.switchToSignUp();
  }

  confirmPasswordSucceded() {
    this.switchToSignIn();
  }

  /** Goes to the Sign Up screen */
  switchToSignUp() {
    this.displayedComponent = this.SIGN_UP;
    this.title = "Register a new account (Step 1 of 2)";
    this.bottomTitleTxt = "Already have an account?"
  }

  /** Goes to the Confirm Signup screen */
  switchToSignUpConfirmation() {
    this.displayedComponent = this.SIGN_UP_CONFIRMATION;
    this.title = "Identity Verification (Step 2 of 2)";
    this.bottomTitleTxt = "Didn't receive the text?"
  }

  /** The user successfully signed up! */
  signUpSuccessfull(selectedValues) {
    this.setSelectedUsrPassword(selectedValues)
    this.switchToSignUpConfirmation();
  }
  signUpFailure(){
    this.switchToSignIn();
  }

  /** We set the username (phone number) and password he selected on the appropriate variables */
  setSelectedUsrPassword(selectedValues) {
    this.selectedUsername = selectedValues.usr;
    this.selectedPassword = selectedValues.pass;
  }

  /** Signs in with cognito */
  signIn(username, password) {
    this.showLoadingOverlay = true;
    //Tries logging in to the server
    //The username we are using right now is a phone number. I need to add +1 to it in order to use it with cognito...
    this.cognito.login(generateCognitoPhoneFormat(username), password)
      .then((response: any) => {
        this.showLoadingOverlay = false;

        if (this.goToCheckoutAfterSignIn) {
          this.avantoRoute.goToCheckoutPage();
        } else {
          this.avantoRoute.goToCustomerDashboardPage();
        }
      })
      .catch(error => {
        if (error.code == "UserNotFoundException") {
          //General error - happens when the login or password are wrong
          Swal.fire('Could not login', "The provided phone number and password combination is invalid.", 'error');

        } else if (error.code == "UserNotConfirmedException") {
          //This happens when the account is registered, but hasnt been activated yet. We send the user to the signup confirmation screen!
          Swal.fire('Could not login', "You need to verify your phone number before you can login. A verification code has been sent.", 'warning');
          this.sendVerificationCode(false);
          this.switchToSignUpConfirmation()
        } else {
          Swal.fire('Could not login', error.message, 'error');
        }

        this.showLoadingOverlay = false;
      })
  }

  /** Requests an SMS confirmation code */
  sendVerificationCode(showMsg?: boolean) {
    if (this.numberOfTimesTryAgainClicked < 10) {
      this.cognito.reSendVerificationCode(generateCognitoPhoneFormat(this.selectedUsername))
        .then(response => {
          if (showMsg) {
            this.Toast.fire({ type: 'success', title: 'Your confirmation code has been sent' })
          }
        })
        .catch((error) => {
          Swal.fire({ type: 'error', title: error.message })
        });
    } else {
      Swal.fire({ type: 'error', title: 'Too many verification codes have been sent. Please, try again later.' })
    }
    this.numberOfTimesTryAgainClicked++;
  }
}
